import { define } from 'wicked-elements'

define('[data-component~="header"]', {
  init() {
    this.$button = this.element.querySelector('button')
    this.toggleMenu = this.toggleMenu.bind(this)
    this.handleResize = this.handleResize.bind(this)
  },
  connected() {
    this.$button.addEventListener('click', this.toggleMenu)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  disconnected() {
    this.$button.removeEventListener('click', this.toggleMenu)
    window.removeEventListener('resize', this.handleResize)
  },
  toggleMenu() {
    document.body.classList.toggle('menu-open')
  },
  handleResize() {
    if (window.innerWidth >= 1024) {
      document.body.classList.remove('menu-open')
    }
  }
})